import { call, put, takeLatest } from 'redux-saga/effects';
import { DeviceMap } from 'types';
import { devicesLoadSuccess, devicesLoadFailure } from 'actions/deviceActions';
import { handleErrorSaga } from 'sagas/app/handleError';
import { getDevices } from 'api';


export function* loadDevicesRequestWatcher() {
    yield takeLatest('DEVICES_LOAD_REQUEST', loadDevicesSaga);
}

export function* loadDevicesSaga() {
    let devices: DeviceMap;
    try {
        devices = yield call(getDevices);
    }
    catch (err) {
        yield call(handleErrorSaga, err, devicesLoadFailure);
        return;
    }
    yield put(devicesLoadSuccess(devices));
}



// WEBPACK FOOTER //
// ./src/sagas/devices/loadDevicesSaga.ts